import {
  Form,
  Row,
  Col,
  Input,
  Button,
  Checkbox,
  InputNumber,
  DatePicker,
} from "antd"
import React, { useContext } from "react"
import styles from "../../Notice/Step/index.module.css"
import AddressForm from "../../AddressForm"
import { NoticeV2Context } from "../index"
import { dateSuffixIcon } from "../../Notice/Step/options"
import * as com from "Common"
import { participantDisplayName } from "../format"

const scoreMaxLimit = 1000

const BorrowerDom = ({ form, fieldName }) => {
  const scoreRangeMin = Form.useWatch(
    ["L3", "disclosureOfUseOfInformation", fieldName, "scoreRangeMin"],
    form
  )
  const scoreRangeMax = Form.useWatch(
    ["L3", "disclosureOfUseOfInformation", fieldName, "scoreRangeMax"],
    form
  )
  return (
    <>
      <Col md={8} xs={24}>
        <Form.Item
          label="Agency"
          name={[fieldName, "agency"]}
          wrapperCol={{ offset: 0 }}
        >
          <Input size="large" />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item
          label="Phone"
          name={[fieldName, "phone"]}
          wrapperCol={{ offset: 0 }}
          getValueFromEvent={(e) => com.fixPhoneInput(e.target.value)}
        >
          <Input size="large" />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item
          label="Date created"
          name={[fieldName, "dateIssued"]}
          wrapperCol={{ offset: 0 }}
        >
          <DatePicker size="large" format="MM/DD/YYYY" suffixIcon={dateSuffixIcon} />
        </Form.Item>
      </Col>
      <AddressForm
        form={form}
        addressName={[fieldName, "address"]}
        stateName={[fieldName, "state"]}
        countyName={[fieldName, "county"]}
        cityName={[fieldName, "city"]}
        zipName={[fieldName, "zipCode"]}
        unitName={[fieldName, "unit"]}
        listName={["L3", "disclosureOfUseOfInformation"]}
      />
      <Col md={8} xs={24}>
        <Form.Item
          label="Credit score"
          name={[fieldName, "creditScore"]}
          wrapperCol={{ offset: 0 }}
        >
          <InputNumber
            min={0}
            max={scoreMaxLimit}
            size="large"
            style={{ width: "100%" }}
            controls={false}
          />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Col md={24} className={styles.label}>Range of possible score</Col>
        <Row>
          <Col md={11}>
            <Form.Item name={[fieldName, "scoreRangeMin"]} wrapperCol={{ offset: 0 }}>
              <InputNumber
                min={0}
                max={(scoreRangeMax || scoreMaxLimit) - 1}
                size="large"
                style={{ width: "100%" }}
                controls={false}
              />
            </Form.Item>
          </Col>
          <Col md={2} className={styles.to}>to</Col>
          <Col md={11}>
            <Form.Item name={[fieldName, "scoreRangeMax"]} wrapperCol={{ offset: 0 }}>
              <InputNumber
                min={(scoreRangeMin || 0) + 1}
                max={scoreMaxLimit}
                size="large"
                style={{ width: "100%" }}
                controls={false}
              />
            </Form.Item>
          </Col>
        </Row>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item
          label="Number of recent inquiries"
          name={[fieldName, "numRecentInquiries"]}
          wrapperCol={{ offset: 0 }}
        >
          <InputNumber min={0} size="large" style={{ width: "100%" }} controls={false} />
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Form.Item label="Factors" name={[fieldName, "factors"]}>
          <Input.TextArea rows={4} placeholder="Add description..." />
        </Form.Item>
      </Col>
    </>
  )
}

const Step3 = () => {
  const { form, setActiveKey, saveDetails, updateLoading, scrollTop } = useContext(NoticeV2Context)
  const disclosures = Form.useWatch(["L3", "disclosureOfUseOfInformation"], form) || []

  return (
    <Row className={[styles.step, styles.step3].join(" ")}>
      <Col className={styles.title} span={24} offset={0}>
        Part 2 - Disclosure of use of information obtained from an outside source
      </Col>
      <Col md={24} xs={24}>
        <Form.Item
          name={["L3", "creditReportBasis"]}
          wrapperCol={{ offset: 0 }}
          valuePropName="checked"
        >
          <Checkbox>
            Our credit decision was based in whole or in part on information obtained in a report from the
            consumer reporting agency listed below.
          </Checkbox>
        </Form.Item>
      </Col>
      <Col span={24} className={styles.divider} />
      <Form.List name={["L3", "disclosureOfUseOfInformation"]}>
        {(fields) =>
          fields.map((field, index) => {
            const participant = disclosures[index] || {}
            const label =
              index === 0
                ? `Borrower - ${participantDisplayName(participant)}`
                : `Co-borrower - ${participantDisplayName(participant)}`
            return (
              <Row gutter={20} key={field.key}>
                <Form.Item name={[field.name, "partyId"]} hidden noStyle>
                  <Input />
                </Form.Item>
                <Col
                  className={styles.title}
                  span={24}
                  style={{ paddingTop: index ? 0 : 20 }}
                >
                  {label}
                </Col>
                <BorrowerDom form={form} fieldName={field.name} />
              </Row>
            )
          })
        }
      </Form.List>
      <Col span={24} className={styles.divider} style={{ paddingTop: 16, marginBottom: 16 }} />
      <Col md={24} xs={24}>
        <Form.Item name={["L3", "obtainOtherData"]} valuePropName="checked">
          <Checkbox className={styles.checkText}>
            Information obtained from an outside source other than a consumer reporting agency. You have the
            right to make a written request of us for disclosure of the nature of this information.
          </Checkbox>
        </Form.Item>
      </Col>
      <Col md={24} xs={24}>
        <Form.Item name={["L3", "hasAdditionalComments"]} valuePropName="checked">
          <Checkbox className={styles.checkText}>Additional statements</Checkbox>
        </Form.Item>
        <Form.Item name={["L3", "additionalComments"]}>
          <Input.TextArea rows={4} placeholder="Add description..." style={{ marginLeft: 20 }} />
        </Form.Item>
      </Col>
      <Col md={8} xs={24}>
        <Form.Item label="Completion of letter by" name={["L3", "completionOfLetterBy"]}>
          <Input size="large" />
        </Form.Item>
      </Col>
      <Col className={styles.optionBtn} span={24}>
        <Button
          type="link"
          size="large"
          onClick={() => {
            setActiveKey("2")
            scrollTop()
          }}
        >
          Back
        </Button>
        <Button
          type="primary"
          size="large"
          loading={updateLoading}
          onClick={async () => {
            await saveDetails()
            setActiveKey("4")
            scrollTop()
          }}
        >
          Next
        </Button>
      </Col>
    </Row>
  )
}

export default Step3
